import React from "react";
import portsecondpic from "../img/portsecondpic.jpeg";
const About = () => {
  return (
    <>
      <div className="a">
        <div className="a-left">
          <div className="a-card bg"></div>
          <div className="a-card">
            <img src={portsecondpic} alt="" className="i-imgg" />
          </div>
        </div>
        <div className="a-right">
          <h1 className="a-title">About Me</h1>
          <p className="a-sub">
            I am seeking for a challenging career Where I can embrace my
            knowledge,all hard work and give the best of mine.
          </p>
          <p className="a-desc">
            <h2> Name : Happy Soni</h2>
            <h3>
              E-mail :{" "}
              <a href="#" class="link">
                21622happysoni@gmail.com
              </a>{" "}
            </h3>
            <p>
              Home Address : Hanuman road (hanuman dhani) Nai Basti Gali no.2,
              Bhiwani, Haryana, India – 127021.
            </p>
            <h3>
              Contact No. : +91{" "}
              <a href="#" class="link">
                8950606625
              </a>{" "}
            </h3>
            <p> Date of Birth : 07-06-2002 </p>
            <p> Fathers Name : Mr. Radhey Shyam</p>
            <p>Nationality : Indian</p>
            <p>Marital Status : unmarried</p>
          </p>
        </div>
      </div>
    </>
  );
};
export default About;
